import { useQuery } from 'react-query';
import { Get } from '@app/utils/httpProvider';
import {
    HOIDONGDAODUC_API,
    NOILAYSOLIEU_API,
    KIEMTRASOLIEU_API,
    HOCPHANBOSUNG_API,
    HOCPHANTIENSI_API,
    CHUYENDETIENSI_API,
    TIEULUANTONGQUAN_API,
    BAOVELUANANCOSO_API,
    PHANBIENDOCLAP_API,
    BAOVECAPVIEN_API
} from '@app/utils/apiUrl';
import { giaiDoanDaoTaoValue } from '@app/utils/define';

export const useTrangThaiGiaiDoan = (hoSoId) => {
    const q1 = useQuery(['hoiDongDaoDucData', hoSoId], () => Get(`${HOIDONGDAODUC_API.GET_BY_HOSO_ID}/${hoSoId}`), { enabled: !!hoSoId });
    const q2_1 = useQuery(['soLieuNghienCuuData', hoSoId], () => Get(`${NOILAYSOLIEU_API.GET_BY_HOSO_ID}/${hoSoId}`), { enabled: !!hoSoId });
    const q2_2 = useQuery(['kiemTraSoLieuData', hoSoId], () => Get(`${KIEMTRASOLIEU_API.GET_BY_HOSO_ID}/${hoSoId}`), { enabled: !!hoSoId });
    const q3 = useQuery(['hocPhanBoSungData', hoSoId], () => Get(`${HOCPHANBOSUNG_API.GET_BY_HOSO_ID}/${hoSoId}`), { enabled: !!hoSoId });
    const q4 = useQuery(['hocPhanTienSiData', hoSoId], () => Get(`${HOCPHANTIENSI_API.GET_BY_HOSO_ID}/${hoSoId}`), { enabled: !!hoSoId });
    const q5 = useQuery(['chuyenDeTienSiData', hoSoId], () => Get(`${CHUYENDETIENSI_API.GET_BY_HOSO_ID}/${hoSoId}`), { enabled: !!hoSoId });
    const q6 = useQuery(['tieuLuanTongQuanData', hoSoId], () => Get(`${TIEULUANTONGQUAN_API.GET_BY_HOSO_ID}/${hoSoId}`), { enabled: !!hoSoId });
    const q7 = useQuery(['baoVeLuanAnCoSoData', hoSoId], () => Get(`${BAOVELUANANCOSO_API.GET_BY_HOSO_ID}/${hoSoId}`), { enabled: !!hoSoId });
    const q8 = useQuery(['phanBienDocLapData', hoSoId], () => Get(`${PHANBIENDOCLAP_API.GET_BY_HOSO_ID}/${hoSoId}`), { enabled: !!hoSoId });
    const q9 = useQuery(['baoVeCapVienData', hoSoId], () => Get(`${BAOVECAPVIEN_API.GET_BY_HOSO_ID}/${hoSoId}`), { enabled: !!hoSoId });

    const getList = (res) => {
        if (!res || !res.data) return [];
        let dt = res.data;
        if (Array.isArray(dt)) return dt;
        if (dt.data && Array.isArray(dt.data)) return dt.data;
        if (dt.$values) return dt.$values;
        if (dt.data && dt.data.$values) return dt.data.$values;
        return [dt];
    };

    const isCompleted = (dataList) => {
        if (!dataList || dataList.length === 0) return false;
        const hasHoanThanh = dataList.some(item => item.trangThai === 'hoanThanh');
        const hasPending = dataList.some(item => item.trangThai !== 'hoanThanh' && item.trangThai !== 'tuChoi');
        return hasHoanThanh && !hasPending;
    };

    const isStage2Completed = (noiLay, kiemTra) => {
        return isCompleted(noiLay) && isCompleted(kiemTra);
    };

    const completedMap = {
        [giaiDoanDaoTaoValue.hoiDongDaoDuc]: isCompleted(getList(q1)),
        [giaiDoanDaoTaoValue.soLieuNghienCuu]: isStage2Completed(getList(q2_1), getList(q2_2)),
        [giaiDoanDaoTaoValue.hocPhanBoSung]: isCompleted(getList(q3)),
        [giaiDoanDaoTaoValue.hocPhanTienSi]: isCompleted(getList(q4)),
        [giaiDoanDaoTaoValue.chuyenDeTienSi]: isCompleted(getList(q5)),
        [giaiDoanDaoTaoValue.tieuLuanTongQuan]: isCompleted(getList(q6)),
        [giaiDoanDaoTaoValue.baoVeCapCoSo]: isCompleted(getList(q7)),
        [giaiDoanDaoTaoValue.phanBienDocLap]: getList(q8).length > 0, // Giai đoạn 8 chỉ cần có dữ liệu
        [giaiDoanDaoTaoValue.baoVeCapVien]: isCompleted(getList(q9)),
        'hocPhanTienSiTab': isCompleted(getList(q3)) && isCompleted(getList(q4)) && isCompleted(getList(q5)) && isCompleted(getList(q6))
    };

    return completedMap;
};
